<!--
 * @Description:
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <jw-input v-if="isQuoteField" class="system-form-item-value ly-form-item-fields-disabled" v-model="modulesItem.fieldValueName" disabled placeholder="-" />
  <!-- supplementData：2025年12月11日18:05:57新增批量添加匹配查找关联条件参数，用于支持批量的关联表格的单独新建弹窗和布局使用 -->
  <xl-association v-else :type="from" :tableId="modulesItem?.setting?.fieldKey == fieldKey ? tableId : ''" :supplementData="modulesItem?.setting?.fieldKey == fieldKey ? supplementData : {}" :singleFieldEdit="singleFieldEdit" :popup-container="popupContainer" :multiple="modulesItem?.setting?.fieldType === 25" :modules-item="modulesItem" :disabled="isQuoteField || modulesItem.businessData == '0' || disabledAll ? true : false" :form-data="from == 35 ? mainForm : formatData" v-model="modulesItem.fieldValue" @change="handleChange" :placeholder="modulesItem?.placeholder || ''" />
</template>

<script setup>
import { ref, inject, computed } from 'vue';
const emits = defineEmits(['cb']);
const isQuoteField = inject('fhFormFieldsParams')?.isQuoteField;
const fieldKey = computed(() => inject('bulkAddParams')?.fieldKey);
const supplementData = computed(() => inject('bulkAddParams')?.supplementData?.value);
const tableId = computed(() => inject('bulkAddParams')?.tableId);

const props = defineProps({
  modules: {
    type: Object,
    default: () => {}
  },
  from: {
    type: Number || String,
    default: () => 20
  },
  disabledAll: {
    type: Boolean,
    default: false
  },
  singleFieldEdit: {
    type: Boolean,
    default: false
  },
  popupContainer: {
    type: String,
    default: ''
  },
  formatData: {
    type: Array,
    default: () => []
  },
  mainForm: {
    type: Array,
    default: () => []
  }
});

const modulesItem = ref(props?.modules);
const handleChange = (id = null, item = null) => {
  if (modulesItem.value?.setting?.fieldType == 25) {
    modulesItem.value['customValue'] = JSON.parse(JSON.stringify(item?.length > 0 ? item : []));
  }
  if (modulesItem.value?.setting?.fieldType == 12) {
    //兼容自定义对象 添加Object格式 { label: '名称', value: 'ID' }
    if (Array.isArray(item)) {
      modulesItem.value['customValue'] = JSON.parse(JSON.stringify(item.length ? item[0] : { label: '', value: '' }));
    } else {
      modulesItem.value['customValue'] = JSON.parse(JSON.stringify(Object.keys(item)?.length > 0 ? item : { label: '', value: '' }));
    }
  }

  console.log('查找关联33', id, item, modulesItem.value);
  emits('cb', modulesItem.value);
};
</script>
